module.exports = __webpack_public_path__ + "img/Thumbnail_SocialCasinos.c3c5cbb3.png";